import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface BudgetListPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class BudgetListPage extends Component<BudgetListPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.budget.list }}
                pages={{
                    entity: InferenceEntities.budget(this.props),
                    list: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}